__turbopack_context__.v({
  "li": "horizontalUl-module__rfHmma__li",
  "root": "horizontalUl-module__rfHmma__root",
});
